import { SectionPageHeader, useSetHeaderMobileInformation } from '@ingenico/react-section-utils';
import { CoreContainer } from '@ingenico/react-ui/core-container';
import { CoreStatus, StatusSize } from '@ingenico/react-ui/core-status';
import { LinearProgress, useMediaQuery } from '@mui/material';
import classNames from 'classnames';

import type { ReactElement } from 'react';
import { useEffect } from 'react';

import { Banner } from '@ingenico/react-ui/banner';
import { isEmpty, toString } from 'lodash-es';
import { CallDetailsInformation } from '../../components/call-details-information/CallDetailsInformation.ctrl';
import { CallLogInformation } from '../../components/call-log-information/CallLogInformation.ctrl';
import { HardwareDetailsInformation } from '../../components/hardware-details-information/HardwareDetailsInformation.ctrl';
import styles from './DeviceCallLogPage.module.scss';
import { useDeviceCallLogPage } from './useDeviceCallLogPage.vm';

export function DeviceCallLogPage(): ReactElement {
  const { data, isError, isLoading, t } = useDeviceCallLogPage();

  const isMobile = useMediaQuery('(max-width: 766px)');

  const setHeaderMobileInformation = useSetHeaderMobileInformation();

  useEffect(() => {
    setHeaderMobileInformation({
      title: toString(t('callLogs:title.details')),
      subtitle: data?.header.subtitle,
      status: data?.header.status.color,
    });
  }, [data?.header.status.color, data?.header.subtitle, setHeaderMobileInformation, t]);

  if (isError) {
    return <Banner message={t('error.default')} />;
  }
  if (isLoading || isEmpty(data)) {
    return <LinearProgress />;
  }

  return (
    <>
      {!isMobile && (
        <SectionPageHeader
          isWhiteBackground
          subHeader={
            <div className={classNames(styles.statusContainer)}>
              <CoreStatus
                data-testid="transation-status-chip"
                size={StatusSize.Medium}
                label={toString(t(`values.status.${data.header.status.label}`))}
                status={data.header.status.color}
              />
            </div>
          }
          subtitle={data.header.subtitle}
          title={toString(t('callLogs:title.details'))}
        />
      )}

      <CoreContainer customMainClassName={classNames(styles.informationsContainer)}>
        <div className={classNames(styles.leftContainer)}>
          <div className={classNames(styles.blackCardContainer)}>
            <CallLogInformation logLines={data.logLines} t={t} />
          </div>
        </div>
        <div className={classNames(styles.rightContainer)}>
          <div className={classNames(styles.whiteCardContainer)}>
            <CallDetailsInformation callDetails={data.callDetails} t={t} />
          </div>
          <div className={classNames(styles.whiteCardContainer)}>
            <HardwareDetailsInformation hardwareDetails={data.hardwareDetails} t={t} />
          </div>
        </div>
      </CoreContainer>
    </>
  );
}
